import { helpers, minLength, required } from "@vuelidate/validators";
import { computed } from "vue-demi";

export const SCR240FormValidateRule = computed(() => ({
  nowPassword: {
    required: helpers.withMessage("現在のパスワードが入力されていません", required),
  },
  newPassword: {
    required: helpers.withMessage("新しいパスワードが入力されていません", required),
    min: helpers.withMessage(({ $params }) => `パスワードは${($params as { min: number }).min}桁以上を入力してください`, minLength(8)),
  },
  newPasswordConfirm: {
    required: helpers.withMessage("新しいパスワード(確認)が入力されていません", required),
  },
}));
